export const DEFAULT_SITE_URL = "https://www.upfest.net";

function parseSiteUrl(value: string): string | undefined {
  try {
    const url = new URL(value);
    if (url.protocol !== "http:" && url.protocol !== "https:") return undefined;

    const pathname = url.pathname.replace(/\/+$/, "");
    return `${url.origin}${pathname === "/" ? "" : pathname}`;
  } catch {
    return undefined;
  }
}

export function normalizeSiteUrl(
  value: string | null | undefined,
  fallback = DEFAULT_SITE_URL,
): string {
  const resolved = parseSiteUrl(value?.trim() ?? "");
  if (resolved) return resolved;

  return parseSiteUrl(fallback.trim()) ?? DEFAULT_SITE_URL;
}

export function requireCanonicalSiteUrl(
  value: string | null | undefined,
): string {
  const siteUrl = normalizeSiteUrl(value);
  if (siteUrl !== DEFAULT_SITE_URL) {
    throw new Error(
      `NUXT_PUBLIC_SITE_URL must be ${DEFAULT_SITE_URL}; received ${siteUrl}`,
    );
  }
  return siteUrl;
}

export function toSiteUrl(path: string, siteUrl = DEFAULT_SITE_URL): string {
  const base = normalizeSiteUrl(siteUrl);
  const parsed = new URL(path.trim() || "/", `${base}/`);
  return new URL(
    `${parsed.pathname}${parsed.search}${parsed.hash}`,
    `${base}/`,
  ).toString();
}
